// extracted by mini-css-extract-plugin
export default {"container":"NotesContainer-module__container___dTNps","inputContainer":"NotesContainer-module__inputContainer___H_5D3"};